import posthog from 'posthog-js';

const initPosthog = (): void => {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;
 
  if (key && host) {
    posthog.init(key, {
      api_host: host,
      autocapture: true,
    });
    console.log('PostHog initialized');
  } else {
    console.log('PostHog not initialized: missing key or host');
  }
};
export {initPosthog};
